var _g, _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 230,
    viewBox: "0 0 227 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_df_1807_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6403 151.507C66.7884 131.174 103.919 140.971 120.591 148.411C127.504 134.271 137.874 129.766 147.634 143.921C165.362 133.553 185.039 140.495 185.785 156.147C193.298 151.188 210.124 146.538 204.561 163.238C220.333 163.404 219.575 186.73 208.759 188.526C208.154 201.619 187.273 204.157 170.901 200.38C162.034 213.916 114.262 221.848 101.498 206.335C88.126 215.051 52.0701 226.606 42.7601 209.591C18.7251 209.869 3.55868 191.043 12.7255 179.313C12.5789 167.273 28.3618 134.028 51.6403 151.507Z",
    fill: "#D8D8D8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.426 103.779C182.426 138.5 152.269 166.647 115.068 166.647C77.8665 166.647 47.709 138.5 47.709 103.779C47.709 69.0581 77.8665 40.9111 115.068 40.9111C152.269 40.9111 182.426 69.0581 182.426 103.779Z",
    fill: "url(#paint0_linear_1807_26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.579 26.9404H119.558V42.9069H109.579V26.9404Z",
    fill: "url(#paint1_linear_1807_26)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 114.566,
    cy: 14.9638,
    r: 13.9707,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.564 171.638C155.245 171.638 187.413 141.704 187.413 104.778C187.413 82.452 175.654 62.6818 157.584 50.5385C155.906 49.4109 153.912 48.8691 151.89 48.8691H79.238C77.2165 48.8691 75.2221 49.4109 73.5442 50.5385C55.4745 62.6818 43.7148 82.4519 43.7148 104.778C43.7148 141.704 75.8828 171.638 115.564 171.638Z",
    fill: "url(#paint2_linear_1807_26)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.4368,
    cy: 147.661,
    rx: 5.28314,
    ry: 9.90588,
    transform: "rotate(-44.9872 64.4368 147.661)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5113 157.514C78.2188 154.766 75.9581 148.148 70.4618 142.733C64.9655 137.318 58.315 135.156 55.6074 137.904C52.8998 140.652 55.1605 147.269 60.6568 152.685C66.1531 158.1 72.8037 160.262 75.5113 157.514ZM70.7894 153.99C72.5122 152.242 71.0737 148.031 67.5765 144.585C64.0792 141.14 59.8475 139.764 58.1247 141.513C56.4019 143.261 57.8404 147.472 61.3376 150.918C64.8349 154.363 69.0666 155.739 70.7894 153.99Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6242 149.987L71.7105 146.066L63.8696 139.894L60.7833 143.814L68.6242 149.987ZM51.9432 155.174L50.9647 150.282L51.9432 155.174ZM41.3877 144.572C40.102 142.135 37.0839 141.202 34.6466 142.487C32.2093 143.773 31.2758 146.791 32.5615 149.228L41.3877 144.572ZM60.7833 143.814C58.0429 147.295 56.0326 148.678 54.7635 149.297C53.4106 149.957 52.7412 149.926 50.9647 150.282L52.9217 160.067C53.6399 159.923 56.2739 159.664 59.1392 158.266C62.0882 156.827 65.2108 154.323 68.6242 149.987L60.7833 143.814ZM50.9647 150.282C51.2149 150.232 50.8788 150.337 49.717 149.977C48.6977 149.661 47.4629 149.117 46.1936 148.402C44.9306 147.69 43.757 146.879 42.8396 146.098C42.3835 145.71 42.027 145.361 41.7671 145.067C41.6389 144.922 41.5453 144.804 41.48 144.713C41.4478 144.668 41.4248 144.633 41.4093 144.608C41.3936 144.584 41.3873 144.572 41.3877 144.572L32.5615 149.228C33.4913 150.991 34.9822 152.516 36.374 153.7C37.8408 154.947 39.5531 156.114 41.2952 157.096C43.0308 158.074 44.9201 158.937 46.7613 159.508C48.4601 160.035 50.7209 160.507 52.9217 160.067L50.9647 150.282Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5835 150.034L71.7168 146.151L63.9508 139.884L60.8175 143.767L68.5835 150.034ZM54.934 154.675L53.2289 149.986L54.934 154.675ZM42.0764 142.777C41.0166 140.234 38.0953 139.031 35.5517 140.091C33.008 141.15 31.8051 144.072 32.865 146.615L42.0764 142.777ZM32.865 146.615C33.1181 147.223 33.4099 147.809 33.7294 148.37L42.4031 143.436C42.2667 143.196 42.1592 142.976 42.0764 142.777L32.865 146.615ZM54.3146 159.936C55.0854 159.829 55.8666 159.645 56.6392 159.364L53.2289 149.986C53.1734 150.006 53.0812 150.033 52.9425 150.052L54.3146 159.936ZM56.6392 159.364C56.8841 159.275 57.1119 159.195 57.3241 159.122L54.0773 149.686C53.8118 149.777 53.5296 149.877 53.2289 149.986L56.6392 159.364ZM68.0839 150.655C68.244 150.455 68.4105 150.248 68.5835 150.034L60.8175 143.767C60.6384 143.989 60.4663 144.203 60.3007 144.409L68.0839 150.655Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1017 148.894C74.042 146.845 72.4673 144.709 70.4618 142.733C67.3517 139.669 63.872 137.646 60.9463 136.965L62.1808 141.1C63.8923 141.655 65.8264 142.861 67.5765 144.585C68.9798 145.968 70.0516 147.474 70.7207 148.894H75.1017Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5388,
    cy: 138.267,
    r: 10.6027,
    transform: "rotate(-30.6263 33.5388 138.267)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.28314,
    cy: 9.90588,
    rx: 5.28314,
    ry: 9.90588,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 177.959 144.647)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.145 157.772C153.437 155.023 155.698 148.406 161.194 142.991C166.691 137.575 173.341 135.413 176.049 138.161C178.756 140.91 176.496 147.527 170.999 152.942C165.503 158.358 158.853 160.52 156.145 157.772ZM160.867 154.248C159.144 152.499 160.583 148.289 164.08 144.843C167.577 141.397 171.809 140.022 173.532 141.77C175.254 143.519 173.816 147.73 170.319 151.175C166.821 154.621 162.59 155.997 160.867 154.248Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.032 150.245L159.946 146.324L167.787 140.151L170.873 144.072L163.032 150.245ZM179.713 155.432L180.692 150.539L179.713 155.432ZM190.269 144.83C191.554 142.393 194.572 141.459 197.01 142.745C199.447 144.031 200.38 147.049 199.095 149.486L190.269 144.83ZM170.873 144.072C173.613 147.553 175.624 148.936 176.893 149.555C178.246 150.215 178.915 150.184 180.692 150.539L178.735 160.325C178.016 160.181 175.382 159.922 172.517 158.524C169.568 157.085 166.445 154.58 163.032 150.245L170.873 144.072ZM180.692 150.539C180.441 150.489 180.777 150.595 181.939 150.235C182.959 149.919 184.193 149.375 185.463 148.659C186.726 147.948 187.899 147.137 188.817 146.356C189.273 145.968 189.629 145.619 189.889 145.325C190.017 145.18 190.111 145.061 190.176 144.971C190.208 144.926 190.231 144.891 190.247 144.866C190.263 144.841 190.269 144.829 190.269 144.83L199.095 149.486C198.165 151.249 196.674 152.773 195.282 153.957C193.815 155.205 192.103 156.372 190.361 157.354C188.625 158.331 186.736 159.195 184.895 159.766C183.196 160.293 180.935 160.765 178.735 160.325L180.692 150.539Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.073 150.291L159.939 146.408L167.705 140.142L170.839 144.025L163.073 150.291ZM176.722 154.933L178.427 150.244L176.722 154.933ZM189.58 143.035C190.64 140.491 193.561 139.289 196.105 140.348C198.648 141.408 199.851 144.329 198.791 146.873L189.58 143.035ZM198.791 146.873C198.538 147.481 198.246 148.067 197.927 148.628L189.253 143.694C189.39 143.454 189.497 143.234 189.58 143.035L198.791 146.873ZM177.342 160.194C176.571 160.087 175.79 159.903 175.017 159.622L178.427 150.244C178.483 150.264 178.575 150.291 178.714 150.31L177.342 160.194ZM175.017 159.622C174.772 159.533 174.544 159.453 174.332 159.38L177.579 149.944C177.844 150.035 178.127 150.135 178.427 150.244L175.017 159.622ZM163.572 150.912C163.412 150.713 163.246 150.506 163.073 150.291L170.839 144.025C171.018 144.247 171.19 144.461 171.356 144.667L163.572 150.912Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.555 149.152C157.614 147.102 159.189 144.966 161.194 142.991C164.305 139.926 167.784 137.904 170.71 137.223L169.475 141.358C167.764 141.913 165.83 143.119 164.08 144.843C162.676 146.226 161.605 147.731 160.936 149.152H156.555Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.6027,
    cy: 10.6027,
    r: 10.6027,
    transform: "matrix(-0.860508 -0.509437 -0.509437 0.860508 212.643 134.803)",
    fill: "#85B7F2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110.578,
    y: 144.693,
    width: 1.49686,
    height: 10.478,
    rx: 0.748429,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 119.557,
    y: 144.696,
    width: 1.49686,
    height: 10.478,
    rx: 0.748429,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.066,
    y: 141.7,
    width: 1.49686,
    height: 17.9623,
    rx: 0.748429,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.9261,
    y: 66.8606,
    width: 115.757,
    height: 60.8722,
    rx: 30.4361,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 3.99162
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 97,
    width: 21,
    height: 3,
    rx: 1.5,
    fill: "#72B2FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 97,
    width: 21,
    height: 3,
    rx: 1.5,
    fill: "#72B2FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_1807_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.7223 141.309C79.5299 126.788 106.028 133.79 117.926 139.106C122.858 129.007 130.257 125.79 137.223 135.902C149.874 128.498 163.916 133.459 164.45 144.639C169.811 141.097 181.817 137.778 177.849 149.706C189.105 149.825 188.567 166.487 180.848 167.768C180.418 177.12 165.517 178.931 153.833 176.231C147.507 185.898 113.418 191.558 104.307 180.476C94.766 186.701 69.0375 194.95 62.3918 182.796C45.2402 182.992 34.4152 169.543 40.9554 161.166C40.8494 152.566 52.1085 128.822 68.7223 141.309Z",
    fill: "#D7D7D7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_1807_26",
    x: 0.0214844,
    y: 125.292,
    width: 226.65,
    height: 104.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1807_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1807_26",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_1807_26"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1807_26",
    x: 29.0273,
    y: 119.736,
    width: 167.467,
    height: 79.3076,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_1807_26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1807_26",
    x1: 115.068,
    y1: 26.9404,
    x2: 115.068,
    y2: 166.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1807_26",
    x1: 115.068,
    y1: 26.9404,
    x2: 115.068,
    y2: 166.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1807_26",
    x1: 115.564,
    y1: 37.9184,
    x2: 115.564,
    y2: 171.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.d4d66226c0176b919a335759d2e68719.svg";
export { ForwardRef as ReactComponent };